<template>
  <!--collapse和unique-opened属性默认值为false可以直接默认，如果要修改需要用:collapse对应参数，否则报false为字符串错误-->
  <el-menu
    :default-active="$router.path"
    class="menu-bar"
    :collapse="isCollapse"
    unique-opened
  >
    <menu-item :menuList="menuList"></menu-item>
  </el-menu>
</template>

<script>
import MenuItem from "./MenuItem.vue"
import { mapState } from "vuex"
export default {
  name: "MenuBar",
  computed: {
    ...mapState({
      //vuex中的左侧菜单数据
      menuList: (state) => state.MenuStore.menu_data,
      //获取vuex中isCollapse的值
      isCollapse: (state) => state.MenuStore.isCollapse,
    }),
  },
  components: {
    MenuItem,
  },
  data() {
    return {}
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
.menu-bar:not(.el-menu--collapse) {
  // width: 260px;
  min-height: 400px;
}
.el-menu {
  border-right: none;
}
</style>
